import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class AsistenciaService {

  private url_listarAsistentes = '';
  private url_listarRespuestas = '';
  private url_porcentajeAsistentes = '';
  private url_configurarPermisoVoto = '';
  private url_buscarTitularesRepresentante = '';
  private url_manejarAsistencia = '';
  private url_reportePdf = '';
  // private url_eliminarAsistentes = environment.apiEndpoint + '/pregunta/traerPreguntaAsamblea';
  // private url_registrarAsistentes = environment.apiEndpoint + '/pregunta/traerPreguntaAsamblea';
  // private url_editarAsistentes = environment.apiEndpoint + '/pregunta/traerPreguntaAsamblea';

  constructor(private _http: HttpClient, private appConfigService: AppConfigService) {
    this.loadConfig();
  }

  loadConfig() {
    const conf = this.appConfigService.getConfig();
    this.url_listarAsistentes = conf.apiEndpoint + '/user/traerAsistencia';
    this.url_listarRespuestas = conf.apiEndpoint + '/user/traerRespuesta';
    this.url_porcentajeAsistentes = conf.apiEndpoint + '/user/porcentajeAsistencia';
    this.url_configurarPermisoVoto = conf.apiEndpoint + '/asamblea/configurarPermisoVoto';
    this.url_buscarTitularesRepresentante = conf.apiEndpoint + '/asamblea/buscarTitularesRepresentantes';
    this.url_manejarAsistencia = conf.apiEndpoint + '/asamblea/manejarAsistencia';
    this.url_reportePdf = conf.apiEndpoint + '/asistencia/reporte/pdf';
  }

  listarAsistente(_idAsamblea: number) {
    return this._http.post(this.url_listarAsistentes, { valor: _idAsamblea, nombre: '' }).toPromise();
  }

  listarRespuesta(_idAsamblea: number, _tipo: number) {
    return this._http.post(this.url_listarRespuestas, {valor: _idAsamblea, nombre: '', tipo: _tipo}).toPromise();
  }

  porcentajeAsistente(_idAsamblea: number) {
    return this._http.post(this.url_porcentajeAsistentes, { valor: _idAsamblea, nombre: '' }).toPromise();
  }

  configurarPermisoVoto(_idAsistente: number, permisoVoto: string) {
    return this._http.post(this.url_configurarPermisoVoto, { valor: _idAsistente, nombre: permisoVoto }).toPromise();
  }

  buscarTitularRepresentante(_idAsamblea: number, _tipoBusqueda: string, _valorBusqueda: string) {
    return this._http.post(this.url_buscarTitularesRepresentante, {
      idAsamblea: _idAsamblea,
      tipoBusqueda: _tipoBusqueda,
      valorBusqueda: _valorBusqueda
    }).toPromise();
  }

  manejarAsistencia(_idAsamblea: number, _idFoto: number,
    _tipoAsistente: string, _usuarioRegistro: string, _modo: string) {
    return this._http.post(this.url_manejarAsistencia, {
      idAsamblea: _idAsamblea,
      idFoto: _idFoto,
      tipoAsistente: _tipoAsistente,
      usuarioRegistro: _usuarioRegistro,
      modo: _modo
    }).toPromise();
  }

  eliminarAsistencia(_idAsamblea: number, _idAsistente: number, _tipoAsistente: string, _idFoto: number) {
    return this._http.post(this.url_manejarAsistencia, {
      idAsamblea: _idAsamblea,
      idAsistente: _idAsistente,
      tipoAsistente: _tipoAsistente,
      idFoto: _idFoto,
      modo: 'E'
    }).toPromise();
  }

  reportePdf(_idAsamblea: number) {
    return this._http.post(this.url_reportePdf, {
      nombre: 'idAsamblea',
      valor: _idAsamblea
    }, { responseType: 'blob' }).toPromise();
  }

}
